module.exports = __webpack_public_path__ + "static/media/中医药大学.5e2a165e.png";